const staticCache = {};

export class LocalCache {

    #cache = {};

    tryGet = (key, value) => {
        value = this.#cache[key];

        return value == undefined;
    }

    getOrAdd = (key, getter) => {
        let value = this.#cache[key];

        if (value === undefined) {
            if (getter !== undefined && typeof getter === 'function') {
                value = getter();
                this.#cache[key] = value;
            }
        }

        return value;
    }

    getOrAddAsync = async (key, getter) => {
        let value = this.#cache[key];

        if (value === undefined) {
            if (getter !== undefined && typeof getter === 'function') {
                value = await getter();
                this.#cache[key] = value;
            }
        }

        return value;
    }
}

export class StaticCache {
    constructor(cacheId) {
        let cache = staticCache[cacheId];
        if (cache === undefined) {
            cache = {};
            staticCache[cacheId] = cache;
        }

        this.cache = cache;
    }

    cache = {};

    get = key => this.cache[key];

    hasKey = (key) => this.cache[key] != undefined;

    getOrAdd = (key, getter) => {
        let value = this.cache[key];

        if (value === undefined) {
            if (getter !== undefined && typeof getter === 'function') {
                value = getter();
                this.cache[key] = value;
            }
        }

        return value;
    }

    getOrAddAsync = async (key, getter) => {
        let value = this.cache[key];

        if (value === undefined) {
            if (getter !== undefined && typeof getter === 'function') {
                value = await getter();
                this.cache[key] = value;
            }
        }

        return value;
    }
}